import * as React from 'react';
import PropTypes from 'prop-types';

import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

import * as Styles from './index.styles';

const { StyledLoading, StyledBackdrop, StyledIcon } = Styles;

export const Loading = ({ visible, icon, ...otherProps }) => (
    <StyledLoading visible={visible} {...otherProps}>
        <StyledBackdrop />
        <StyledIcon icon={icon} spin />
    </StyledLoading>
);

Loading.propTypes = {
    visible: PropTypes.bool,
    fixed: PropTypes.bool,
    icon: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string, PropTypes.object]),
};

Loading.defaultProps = {
    visible: false,
    fixed: false,
    icon: faSpinnerThird,
};

Loading.Styles = Styles;
